import React, { useState, useEffect } from 'react';
import Checkbox from '@tencent/dui/lib/components/Checkbox';
import Radio from '@tencent/dui/lib/components/Radio';
import i18n from '@i18next/i18n';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import style from './style.less';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { IMasterModel } from '@src/slide/domain/ui-model/element-modeles/Interface/master-model.interface';
import { IQuickToolDialogManagerDelegates } from '../quick-tool-dialog-manager.interface';

interface Props {
    onCheckStateChange: (slidesList: ISlideModel[]) => void;
    needGetSelectModels: boolean;
    services: Pick<IQuickToolDialogManagerDelegates, 'masterLayoutEditService' | 'selectionService'>;
}

export type IPageRange = React.FC<Props>;
// eslint-disable-next-line complexity
const PageRange: IPageRange = (props: Props) => {
    const { onCheckStateChange, needGetSelectModels, services } = props;

    const isMasterEditing = services.masterLayoutEditService?.isMasterEditType;
    const [currentPage, setCurrentPage] = useState(isMasterEditing || false);
    const [ignoreFirst, setIgnoreFirst] = useState(false);
    const [ignoreLast, setIgnoreLast] = useState(false);
    const [includeHide, setIncludeHide] = useState(true);

    const hasSelectedElements = services.selectionService.selectedElements.selectedArray?.length;

    const handleCurrentPageCheckedChange = (checked: boolean) => {
        setIgnoreFirst(false);
        setIgnoreLast(false);
        if (checked) {
            setIncludeHide(false);
        } else {
            setIncludeHide(true);
        }
        setCurrentPage(checked);
    };

    const getSelectedSlide = (): ISlideModel[] => {
        const { selectionService } = services;
        if (needGetSelectModels && hasSelectedElements && selectionService.currentSlide) {
            // 仅处理当前选中的元素的情况，当前页的数据一定转完了，造一个假的slide把选中元素塞进children中
            const fakeSlide = {
                children: selectionService.selectedElements.selectedArray,
                width: selectionService.currentSlide.width,
                height: selectionService.currentSlide.height,
                childrenConverted: selectionService.currentSlide.childrenConverted,
                startConvertChildrenTask: selectionService.currentSlide.startConvertChildrenTask,
                getBatchUpdateFrame: selectionService.currentSlide.getBatchUpdateFrame,
            };
            return [fakeSlide as unknown as ISlideModel];
        }
        let slidesList: ISlideModel[] = [...selectionService.slides];
        if (currentPage && selectionService.currentSlide) {
            slidesList = [selectionService.currentSlide];
        } else {
            if (ignoreFirst) {
                slidesList.splice(0, 1);
            }
            if (ignoreLast) {
                slidesList.splice(-1, 1);
            }
            if (!includeHide) {
                slidesList = slidesList.filter(slide => slide.isShowInPlay);
            }
            if (selectionService.currentSlideType === UIModelType.MASTER) {
                const { currentSlide } = selectionService;
                slidesList = [currentSlide, ...(currentSlide as IMasterModel).layoutList];
            }
        }
        return slidesList;
    };

    const getContentHasSelectedElements = () => <Checkbox
        checked={true}
        disabled={true}>
        {i18n.t('仅选中图片')}
    </Checkbox>;

    const getContentNoSelectedElements = () => <div className={style['page-range-wrapper']}>
        <Radio.Group
            className={style['current-page-wrapper']}
            onChange={(value) => {
                handleCurrentPageCheckedChange(!!value);
            }}
            defaultValue={0}
        >
            <Radio value={0}>
                <div>{i18n.t('全部页面')}</div>
            </Radio>
            <Radio value={1}>
                <div>{i18n.t('仅当前页面')}</div>
            </Radio>
        </Radio.Group>
        {
            (!isMasterEditing && !currentPage)
        && <div className={style['extra-select-wrapper']}>
            <Checkbox
                onChange={checked => setIncludeHide(checked)}
                checked={includeHide}>
                {i18n.t('包含隐藏页面')}
            </Checkbox>
            <Checkbox
                onChange={checked => setIgnoreFirst(checked)}
                checked={ignoreFirst}>
                {i18n.t('忽略首页')}
            </Checkbox>
            <Checkbox
                onChange={checked => setIgnoreLast(checked)}
                checked={ignoreLast}>
                {i18n.t('忽略尾页')}
            </Checkbox>
        </div>
        }
    </div>;

    useEffect(() => {
        onCheckStateChange(getSelectedSlide());
        if (!isMasterEditing && (ignoreFirst || ignoreLast || includeHide)) {
            setCurrentPage(false);
        }
    }, [currentPage, ignoreFirst, ignoreLast, includeHide]);

    return (
        <div style={{ width: '100%' }}>
            {
                (needGetSelectModels && hasSelectedElements)
                    ? getContentHasSelectedElements()
                    : getContentNoSelectedElements()
            }

        </div>
    );
};

export default PageRange;
